import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'

import {BASE_CLASS_NAME} from '../../config.js'
import {usePublishMyAdWithPlateAnalyticsTrack} from '../../hooks/usePublishMyAdWithPlateAnalyticsTrack.js'
import CardVehicle from '../CardVehicle/index.js'
import Title from '../Title/index.js'

const VehicleConfirmationSellerPlate = ({
  isLoading = false,
  onDenySelection,
  onSelectVehicle,
  vehicleData: {km, plate, ...vehicleData}
}) => {
  const {i18n} = useContext(Context)

  const {trackShowResultsVehicleData} = usePublishMyAdWithPlateAnalyticsTrack()

  useMount(() => trackShowResultsVehicleData({resultsNumber: 1})) // this component shows only one result, so its the first vehicle selected

  const handleOnConfirm = () => {
    onSelectVehicle()
  }

  const handleOnWrongData = () => {
    onSelectVehicle({plateStatus: 'plateEditField'})
  }

  return (
    <>
      <Title title={i18n.t('PUBLISH_AD.WITH_PLATE.CAR_WITH_PLATE_FOUND')} />
      <CardVehicle vehicleData={vehicleData} />
      <div className={`${BASE_CLASS_NAME}-wrongData ${BASE_CLASS_NAME}-wrongDataText`}>
        {i18n.t('PUBLISH_AD.WITH_PLATE.DATA_WRONG')}
        <div className={`${BASE_CLASS_NAME}-wrongDataButton`}>
          <AtomButton
            design={atomButtonDesigns.LINK}
            disabled={isLoading}
            onClick={handleOnWrongData}
            size={atomButtonSizes.SMALL}
          >
            <span className={`${BASE_CLASS_NAME}-wrongDataText`}>{i18n.t('PUBLISH_AD.WITH_PLATE.FIX_DATA')}</span>
          </AtomButton>
        </div>
      </div>
      <div className={`${BASE_CLASS_NAME}-buttonGroup`}>
        <div className={`${BASE_CLASS_NAME}-button`}>
          <AtomButton
            fullWidth
            isLoading={isLoading}
            onClick={handleOnConfirm}
            shape={atomButtonShapes.CIRCULAR}
            size={atomButtonSizes.LARGE}
          >
            {i18n.t('PUBLISH_AD.WITH_PLATE.MY_CAR')}
          </AtomButton>
        </div>
        <div className={`${BASE_CLASS_NAME}-buttonSecondary`}>
          <AtomButton
            design={atomButtonDesigns.LINK}
            disabled={isLoading}
            fullWidth
            onClick={onDenySelection}
            size={atomButtonSizes.LARGE}
          >
            {i18n.t('PUBLISH_AD.WITH_PLATE.NOT_MY_CAR')}
          </AtomButton>
        </div>
      </div>
    </>
  )
}

VehicleConfirmationSellerPlate.displayName = 'VehicleConfirmationSellerPlate'

VehicleConfirmationSellerPlate.propTypes = {
  isLoading: PropTypes.bool,
  onDenySelection: PropTypes.func.isRequired,
  onSelectVehicle: PropTypes.func.isRequired,
  vehicleData: PropTypes.object.isRequired
}

export default VehicleConfirmationSellerPlate
